import { isBackdrop } from "./IXXFVVA2.js";
import { setAttribute } from "./FW6QFGFT.js";
import { walkTreeOutside } from "./5M4ITSXL.js";

// src/dialog/utils/disable-accessibility-tree-outside.ts
function hideElementFromAccessibilityTree(element) {
  return setAttribute(element, "aria-hidden", "true");
}
function disableAccessibilityTreeOutside() {
  const cleanups = [];
  for (var _len = arguments.length, elements = new Array(_len), _key = 0; _key < _len; _key++) {
    elements[_key] = arguments[_key];
  }
  const ids = elements.map(el => el == null ? void 0 : el.id);
  walkTreeOutside(elements, element => {
    if (isBackdrop(element, ...ids)) return;
    cleanups.unshift(hideElementFromAccessibilityTree(element));
  });
  const restoreAccessibilityTree = () => {
    cleanups.forEach(fn => fn());
  };
  return restoreAccessibilityTree;
}
export { hideElementFromAccessibilityTree, disableAccessibilityTreeOutside };